import { BinderClassificationDtoV2 } from 'src/app/shared/interfaces';
import { FolderClassificationDetails } from './classeur';

export class ClassificationInfos {
  id: number;
  description: string;
  code: string;
  actif: boolean;
  serviceId: number;
  classeurs: FolderClassificationDetails[];

  value?: ClassificationInfos;

  constructor(data?: Partial<BinderClassificationDtoV2>) {
    Object.assign(this, data);
  }
}
